module.exports = __webpack_public_path__ + "static/media/guide_step4.b2e4f835.png";